import SiteRoutes from "./components/Siteroutes";


function App() {
  return <SiteRoutes />;
}

export default App;
